document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('.sticky-atc-bar');
  if (!bar) return;

  var sectionId = bar.id.replace('StickyAtcBar-', '');
  var barSubmit = bar.querySelector('[data-sticky-buy-now]');

  // Keep sold-out / availability state in sync with the real add-to-cart button.
  var realForm = document.getElementById('product-form-' + sectionId);
  var realSubmit = realForm ? realForm.querySelector('[type="submit"]') : null;

  if (realSubmit && barSubmit) {
    var syncState = function () {
      var disabled =
        realSubmit.hasAttribute('disabled') || realSubmit.getAttribute('aria-disabled') === 'true';
      if (disabled) {
        barSubmit.setAttribute('disabled', 'disabled');
      } else {
        barSubmit.removeAttribute('disabled');
      }
    };
    syncState();
    new MutationObserver(syncState).observe(realSubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
    });
  }

  // Buy It Now: add the current variant straight to the cart, then jump
  // directly to checkout (skips the cart page/drawer entirely).
  if (barSubmit) {
    barSubmit.addEventListener('click', function () {
      if (barSubmit.hasAttribute('disabled')) return;

      var formEl = document.getElementById('product-form-' + sectionId);
      if (!formEl) return;

      var formData = new FormData(formEl);
      // Route through /cart/add.js as JSON so we control the redirect ourselves.
      var body = new URLSearchParams();
      formData.forEach(function (value, key) {
        body.append(key, value);
      });

      barSubmit.setAttribute('disabled', 'disabled');
      var originalText = barSubmit.querySelector('span').textContent;
      barSubmit.querySelector('span').textContent = 'Adding...';

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body,
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error((err && err.description) || 'Could not add item to cart');
            });
          }
          window.location.href = '/checkout';
        })
        .catch(function (error) {
          barSubmit.removeAttribute('disabled');
          barSubmit.querySelector('span').textContent = originalText;
          window.alert(error.message || 'Something went wrong. Please try again.');
        });
    });
  }
const stopSection = document.querySelector('.lbs-link-section');

if (stopSection) {
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        bar.style.display = 'none';
      } else {
        bar.style.display = 'flex';
      }
    });
  }, {
    threshold: 0
  });

  observer.observe(stopSection);
}

  
});
